'use client';

import * as React from 'react';
import { mergeProps } from '../../merge-props/index.js';
export function useFieldsetRoot() {
  const [legendId, setLegendId] = React.useState(undefined);
  const getRootProps = React.useCallback((externalProps = {}) => mergeProps({
    'aria-labelledby': legendId
  }, externalProps), [legendId]);
  return React.useMemo(() => ({
    getRootProps,
    legendId,
    setLegendId
  }), [getRootProps, legendId]);
}